/**
 * Notification Store
 *
 * Zustand store for managing notifications
 * Follows the project's clean architecture patterns
 */

import {create} from 'zustand';
import {Notification} from '../../../Services/common/NotificationTypes';

interface NotificationState {
  notifications: Notification[];
  addNotification: (notification: Omit<Notification, 'id'>) => string;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
  setNotifications: (notifications: Notification[]) => void;
}

export const useNotificationStore = create<NotificationState>((set, get) => ({
  notifications: [],

  addNotification: (notification: Omit<Notification, 'id'>) => {
    const id = crypto.randomUUID ? crypto.randomUUID() : `notification-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const newNotification = {...notification, id};

    set(state => ({
      notifications: [...state.notifications, newNotification]
    }));

    // Auto-remove notification after duration
    if (notification.duration !== 0) {
      setTimeout(() => {
        get().removeNotification(id);
      }, notification.duration || 5000);
    }

    return id;
  },

  removeNotification: (id: string) => {
    set(state => ({
      notifications: state.notifications.filter(n => n.id !== id)
    }));
  },

  clearNotifications: () => {
    set({notifications: []});
  },

  setNotifications: (notifications: Notification[]) => {
    set({notifications});
  }
}));


